import React, { useState } from "react";
import { Box, IconButton, Menu } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import styled from "styled-components";

interface ActionsMenuProps {
  render: (React.ReactElement | false | null)[];
  numberOfActions?: number;
  buttonDirection?: "horizontal" | "vertical";
}

const StyledBox = styled(Box)({
  gap: `4px`,
  padding: "8px",
  "& > button": {
    width: "100%",
  },
});

const ActionsMenu: React.FC<ActionsMenuProps> = ({
  render,
  numberOfActions = 2,
  buttonDirection = "vertical",
}) => {
  const filteredRender = render.filter(Boolean);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      display="flex"
      flexDirection={buttonDirection === "vertical" ? "row" : "column"}
      justifyContent="flex-start"
      alignItems="flex-start"
      style={{
        gap: `4px`, // Use gap for spacing between items
      }}
    >
      {filteredRender.map((action, index) => {
        if (index < numberOfActions)
          return <React.Fragment key={index}>{action}</React.Fragment>;
        return null;
      })}

      {filteredRender.length > numberOfActions && (
        <>
          <Tooltip title="More actions">
            <IconButton onClick={handleOpen} style={{ padding: "6px" }}>
              <MoreVertIcon color="primary" />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            disablePortal
            PaperProps={{ style: { zIndex: 1 } }}
          >
            {filteredRender.map((action: any, index) => {
              if (index > numberOfActions - 1)
                return (
                  <StyledBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-start"
                    alignItems="center"
                    key={index}
                  >
                    {action}
                  </StyledBox>
                );
            })}
          </Menu>
        </>
      )}
    </Box>
  );
};

export default ActionsMenu;
